import { Badge } from './ui/badge';
import { Clock, CheckCircle2, XCircle, Trash2 } from 'lucide-react';

export const StatusBadge = ({ status }) => {
  const config = {
    pending: {
      label: 'Pending',
      className: 'bg-amber-100 text-amber-800 border-amber-200 hover:bg-amber-100',
      icon: Clock
    },
    approved: {
      label: 'Approved',
      className: 'bg-green-100 text-green-800 border-green-200 hover:bg-green-100',
      icon: CheckCircle2
    },
    rejected: {
      label: 'Rejected',
      className: 'bg-red-100 text-red-800 border-red-200 hover:bg-red-100',
      icon: XCircle
    },
    deleted: {
      label: 'Deleted',
      className: 'bg-gray-100 text-gray-800 border-gray-300 hover:bg-gray-100',
      icon: Trash2
    }
  };

  const { label, className, icon: Icon } = config[status] || config.pending;

  return (
    <Badge variant="outline" className={`${className} gap-1 font-medium`}>
      <Icon className="w-3 h-3" />
      {label}
    </Badge>
  );
};
